import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './shared/styles/global.css'
import './shared/lib/i18n'
import { initSentry } from './shared/lib/sentry'
import App from './app/App'
import { AppErrorBoundary } from './app/AppErrorBoundary'
import { AppProviders } from './app/providers/AppProviders'

initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
)
